(function () {
  function sync() {
    if (document.body.classList.contains('template-password')) return;
    var footer = document.querySelector('.section-footer');
    var frame = document.querySelector('.page-frame');
    if (!footer || !frame) return;

    var h = footer.offsetHeight;

    if (document.body.classList.contains('template-product')) {
      // Transform approach: the document never scrolls, so scrollIntoView on
      // images can't accidentally trigger the reveal. Instead we lift the
      // entire page-frame via CSS transform, which automatically drags the
      // position:fixed header along as one unit.
      footer.style.display = '';
      frame.style.paddingBottom = '';
      frame.style.marginBottom = '';
      document.documentElement.style.setProperty('--footer-reveal-distance', '-' + h + 'px');
    } else {
      frame.style.marginBottom = '';
      frame.style.paddingBottom = h + 'px';
    }
  }

  function setupScrollChain() {
    var imagesEl = document.querySelector('.project-info__images');
    var frame = document.querySelector('.page-frame');
    if (!imagesEl || !frame) return;

    var revealed = false;

    function reveal() {
      if (revealed) return;
      revealed = true;
      document.body.classList.add('footer-revealed');
    }

    function hide() {
      if (!revealed) return;
      revealed = false;
      document.body.classList.remove('footer-revealed');
    }

    // Listen on page-frame with capture so we intercept before imagesEl.
    // When at the last image and scrolling down: lift the whole frame.
    // When revealed and scrolling up: drop it back.
    frame.addEventListener('wheel', function (e) {
      var atEnd = imagesEl.scrollTop + imagesEl.clientHeight >= imagesEl.scrollHeight - 20;

      if (e.deltaY > 0 && atEnd && !revealed) {
        e.preventDefault();
        reveal();
      } else if (e.deltaY < 0 && revealed) {
        e.preventDefault();
        hide();
      }
    }, { passive: false, capture: true });
  }

  function init() {
    sync();
    if (document.body.classList.contains('template-product')) {
      setupScrollChain();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', sync);
})();
